<template>
  <div>
    <!-- создание и редактирование шагов пакета -->
    <el-dialog
      visible
      v-if="jobsFlag"
      width="80%"
      :title="$t('jobForms.stepsAndTasksEdit') + ' ' + selectedPacket.name"
      :close-on-click-modal="false"
      @close="cancelJobClick"
    >
      <el-form label-position="left" class="main-form-scroll">
        <div
          v-for="(job, index) in jobArray"
          :key="index"
          class="el-form-line"
          :ref="'job' + index"
        >
          <div class="select-line">
            <label>{{ $t("jobForms.app") + ":" }}</label>
            <el-select
              v-model="job.idSection"
              filterable
              @change="jobAppChanged(job)"
            >
              <el-option
                v-for="(app, index) in getAppsArray"
                :key="index"
                :value="app.id"
                :label="
                  app.alias ? app.name + ' (' + app.alias + ')' : app.name
                "
              ></el-option>
            </el-select>
          </div>
          <div class="select-line">
            <label>{{ $t("jobForms.template") + ":" }}</label>
            <el-select
              v-model="job.templateId"
              :key="taskKey"
              filterable
              @change="jobTemplateChanged(job)"
            >
              <el-option
                v-for="(tmp, index) in job.templates"
                :key="index"
                :value="tmp.id"
                :label="tmp.name"
              ></el-option>
            </el-select>
          </div>
          <el-checkbox v-model="job.disable">{{
            $t("jobForms.block")
          }}</el-checkbox>
          <div v-if="job.showJobTasks" :key="taskKey" class="tasks-list">
            <label class="task-container-label">{{
              $t("jobForms.tasks") + ":"
            }}</label>
            <div
              v-for="(task, taskIndex) in job.taskArray"
              :key="taskIndex"
              class="tasks-list-item"
            >
              <span class="task-text-general">
                <span class="task-text"
                  >{{ task.caption }} &horbar;
                  {{ task.params }}
                  <!-- <span v-if="task.templateParams"
                    >{{ task.templateParams }}
                  </span> -->
                </span>
              </span>
              <span class="right-side-container">
                <el-select
                  v-model="task.base"
                  v-if="
                    task.templateParams.includes('BaseName') ||
                    task.templateParams.includes('BaseShortName')
                  "
                  filterable
                  @change="baseInTaskArrayChanged(task, job.basesInSection)"
                  :placeholder="$t('jobForms.base')"
                  class="base-select"
                >
                  <el-option
                    v-for="(base, index) in job.basesInSection"
                    :key="index"
                    :value="base.idBase"
                    :label="baseLabel(base)"
                  ></el-option>
                </el-select>

                <el-tooltip
                  v-if="
                    task.templateParams.includes('BaseName') ||
                    task.templateParams.includes('BaseShortName')
                  "
                  :content="$t('jobForms.allBases')"
                  placement="bottom-start"
                  effect="light"
                >
                  <el-button
                    size="mini"
                    icon="el-icon-finished"
                    class="all-bases-button"
                    @click="setAllBases(job, task, taskIndex)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  :content="$t('jobForms.quanity')"
                  placement="bottom-start"
                  effect="light"
                >
                  <el-input-number
                    size="small"
                    :controls="false"
                    :precision="0"
                    :min="1"
                    class="copy-number"
                    v-model="task.numOfRepeats"
                    @change="enterNumOfRepeats(job, task, taskIndex)"
                  ></el-input-number>
                </el-tooltip>
                <el-button
                  v-if="hasSiblings(task, taskIndex, job.taskArray)"
                  type="text"
                  class="delete-button"
                  @click="deleteCopied(job, taskIndex)"
                  >x</el-button
                >
              </span>
              <!-- <br /> -->
            </div>
          </div>

          <div class="buttons">
            <el-button
              @click="addJob(job)"
              icon="el-icon-plus"
              size="mini"
            ></el-button>
            <el-button
              @click.prevent="removeElement(job, jobArray, addJob)"
              icon="el-icon-delete"
              size="mini"
            ></el-button>
            <el-button
              @click.prevent="moveUp(job, jobArray)"
              icon="el-icon-top"
              size="mini"
            ></el-button>
            <el-button
              @click.prevent="moveDown(job, jobArray)"
              icon="el-icon-bottom"
              size="mini"
            ></el-button>
            <!-- <span class="nn-index">[{{index}}]</span> -->
          </div>
        </div>
      </el-form>
      <div slot="footer" class="bottom-buttons">
        <div></div>
        <div>
          <el-button
            class="button-cancel"
            type="plain"
            @click="cancelJobClick"
            >{{ $t("jobForms.cancel") }}</el-button
          >
          <el-button class="button-confirm" type="success" @click="okJobClick"
            >OK</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import arrayWorkMixin from "./arrayWorkMixin";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      jobArray: [], //{template, disable, templates(for section), idSection, taskArray, basesInSection, showJobTasks}
      taskKey: 0,
      newSection: "47",
      key: 0,
      taskForSectionChange: null,
    };
  },
  methods: {
    jobAppChanged(job) {
      job.showJobTasks = false;
      job.templateId = null;
      this.$store
        .dispatch("getCronTemplates")
        .then((result) => {
          // console.log(job);
          job.templates = result;
          return this.$store.dispatch("getBasesSection", job.idSection);
        })
        .then((basesInSection) => {
          job.basesInSection = basesInSection;
          if (job.taskArray.length > 0) {
            this.changeKey(job);
          } else {
            job.templateId = null;
          }
          this.taskKey++;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    jobTemplateChanged(job) {
      // console.log("jobTemplateChanged", job);
      job.showJobTasks = false;
      this.$store
        .dispatch("getCronTemplateTasks", job.templateId)
        .then(() => {
          // job.taskArray = [...this.cronTemplateTasks];
          job.taskArray = [];
          this.templateTasks.forEach((tt) => {
            let temp = {
              base: null,
              templateParams: tt.params,
              numOfRepeats: 1,
              ...tt,
            };
            job.taskArray.push(temp);
          });
          this.changeKey(job);
          // this.jobAppChanged(job);
          job.showJobTasks = true;
        })
        .catch((error) => console.error(error));
    },
    enterNumOfRepeats(job, task, taskIndex) {
      if (task.numOfRepeats <= 1) {
        return;
      }
      const numOfRepeats = task.numOfRepeats - 1;
      task.numOfRepeats = 1;
      // let taskArray = [...job.taskArray];
      const newTask = this.createNewTask(task);
      for (let numCopied = 0; numCopied < numOfRepeats; numCopied++) {
        job.taskArray.splice(taskIndex + 1 + numCopied, 0, { ...newTask });
      }
      this.taskKey++;
    },
    createNewTask(task, idBase) {
      let newTask = {
        ...task,
        numOfRepeats: 1,
      };
      if (idBase) {
        newTask.base = idBase;
      }
      return newTask;
    },
    setAllBases(job, task, taskIndex) {
      let newArray = [];
      task.base = job.basesInSection[0].idBase;
      for (let i = 1; i < job.basesInSection.length; i++) {
        newArray.push(this.createNewTask(task, job.basesInSection[i].idBase));
      }
      this.baseInTaskArrayChanged(task, job.basesInSection);
      for (let newTask of newArray) {
        this.baseInTaskArrayChanged(newTask, job.basesInSection);
      }
      job.taskArray.splice(taskIndex + 1, 0, ...newArray);
    },
    deleteCopied(job, taskIndex) {
      job.taskArray.splice(taskIndex, 1);
    },
    hasSiblings(task, taskIndex, taskArray) {
      const taskBefore = taskArray[taskIndex - 1];
      const taskAfter = taskArray[taskIndex + 1];
      if (taskBefore && taskAfter) {
        if (taskAfter.path === task.path && taskBefore.path !== task.path) {
          // если нижний -- такой же, а верхний -- нет
          return false;
        } else if (taskBefore.path === task.path) {
          return true;
        }
      } else if (taskBefore && !taskAfter && taskBefore.path === task.path) {
        //  is last
        return true;
      } else if (taskAfter && !taskBefore && taskAfter.path === task.path) {
        // is first
        return false;
      }
      return false;
    },
    changeKey(job) {
      let appHome = this.getAppsArray.find(
        (section) => section.id === job.idSection
      ).path;
      let appName = this.getAppsArray.find(
        (section) => section.id === job.idSection
      ).name;
      for (let task of job.taskArray) {
        this.changeTaskAppParams(task, appHome, appName);
      }
    },
    changeTaskAppParams(task, appHome, appName) {
      let curParams = task.templateParams;
      // task.base = null;
      curParams = curParams.replace(/{{AppHome}}/gi, appHome);
      curParams = curParams.replace(/{{AppName}}/gi, appName);
      task.params = curParams;

      let tempPath;
      if (task.templatePath) tempPath = task.templatePath;
      else tempPath = task.path;
      const fullPathStart = "/usr/appserv/";
      if (tempPath[0] === "~") {
        // если есть тильда - заменяем на полный путь
        tempPath = fullPathStart + appHome + tempPath.replace("~", "");
      } else if (tempPath[0] !== "/")
        this.$message.error(`${this.$t("jobForms.pathError")}: `, task.path);
      if (!task.templatePath) task.templatePath = task.path;
      task.path = tempPath;
      this.taskKey++;
    },
    baseInTaskArrayChanged(task, bases) {
      const base = bases.find((base) => base.idBase === task.base);
      const name = base.bname;
      const shortName = base.shortName;
      const templateParamsArray = task.templateParams.split(" ");
      let curParamsArray = task.params.split(" ");
      const baseNameIndex = templateParamsArray.indexOf("'{{BaseName}}'");
      const shortBaseNameIndex = templateParamsArray.indexOf(
        "'{{BaseShortName}}'"
      );
      curParamsArray[shortBaseNameIndex] = "'" + shortName + "'";
      // curParamsArray[baseNameIndex] = "'" + name + "'";
      curParamsArray[baseNameIndex] = "'" + name + "'";
      this.taskKey++;
      task.params = curParamsArray.join(" ");
    },

    addJob(job) {
      let index = this.jobArray.indexOf(job);
      // //console.log(param);
      this.jobArray.splice(index + 1, 0, {
        templateId: null,
        idSection: null,
        disable: false,
        taskArray: [],
        showJobTasks: false,
      });
      const ref = `job${index + 1}`;
      this.$nextTick()
        .then(() => {
          const newElement = this.$refs[ref];
          newElement[0].scrollIntoView();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    cancelJobClick() {
      this.$store.commit("setJobsFlag", false);
      this.jobArray = [];
    },
    okJobClick() {
      if (
        this.jobArray.length === 1 &&
        (!this.jobArray[0].idSection || !this.jobArray[0].templateId)
      ) {
        // removed all jobs, need to save
        this.jobArray = [];
      }
      let jobArray = [];
      let jobTasksArray = [];
      let jobIndex = 1;
      let validate = true;
      this.jobArray.forEach((j) => {
        //[idPacket, nn, idSection, tpName, disable]
        let job = {
          idPacket: this.selectedPacket.id,
          nn: `${jobIndex}`,
          idSection: j.idSection,
          tpName: this.cronTemplates.find((t) => t.id === j.templateId).name,
          disable: j.disable ? "1" : "0",
        };
        let jobTasks = [];
        let taskIndex = 1;
        j.taskArray.forEach((t) => {
          //idJob, nn, caption, path, params
          let task = {
            nn: `${taskIndex}`,
            caption: t.caption,
            path: t.path,
            params: t.params,
            templatePath: t.templatePath,
            templateParams: t.templateParams,
          };
          if (
            t.params.includes("{{BaseName}}") ||
            t.params.includes("{{BaseShortName}}")
          ) {
            this.$store.commit(
              "setError",
              this.$t("jobForms.noBaseSelectedForTask")
            );
            validate = false;
          }
          if (
            t.params.includes("{{AppName}}" || t.params.includes("{{AppHome}}"))
          ) {
            this.$store.commit(
              "setError",
              `${this.$t("jobForms.problemWithAppSelect")}. ${this.$t(
                "jobForms.tryToDeleteStepAndRecreate"
              )}`
            );
            validate = false;
          }
          jobTasks.push(task);
          taskIndex++;
        });
        job.tasks = jobTasks;
        // console.log(jobTasks);
        jobArray.push(job);
        jobIndex++;
      });
      let packet = {
        idPacket: this.selectedPacket.id,
        jobs: jobArray,
      };
      // console.log(packet);
      if (validate) {
        // console.log("VALIDATE");
        // sconsole.log(packet);
        this.$store
          .dispatch("setJobsInPacket", packet)
          .then(() => {
            this.jobArray = [];
            this.$store.commit("setJobsFlag", false);
          })
          .catch(() => {
            this.$store.commit("setJobsFlag", false);
          });
        // console.log(jobTasksArray);
      } else this.$message.error(this.$t("jobForms.problemWithAppSelect"));
    },
    parseIncomingParams(task, bases) {
      const incomingParams = task.params.split(" ");
      const templateParams = task.templateParams.split(" ");
      templateParams.forEach((param, index) => {
        if (param === "'{{BaseName}}'") {
          const baseName = incomingParams[index].replace(/'/gi, "");
          let base = bases.find((base) => base.bname === baseName);
          let wrongBase = bases.find((base) => base.shortName === baseName);
          if (!base && wrongBase) {
            this.$message(
              `${this.$t("jobForms.baseNameNoShortName")}: ${wrongBase.bname}.`
            );
            base = wrongBase;
          } else if (!base && !wrongBase) {
            this.$message(
              `${this.$t("jobForms.incorrectlyEnteredData")}: ${baseName}`
            );
            task.params = task.params.replace(baseName, "{{BaseName}}");
            task.base = null;
            return;
          }
          task.base = base.idBase;
        } else if (param === "'{{BaseShortName}}'") {
          const baseShortName = incomingParams[index].replace(/'/gi, "");
          let base = bases.find((base) => base.shortName === baseShortName);
          if (!base) {
            this.$message(
              `${this.$t(
                "jobForms.oneOfParamBaseNameNotdetermined"
              )}. ${this.$t("jobForms.baseWillNotBeAutoSubstituted")}.`
            );
            task.params = task.params.replace(baseName, "{{BaseShortName}}");
            task.base = null;
          } else task.base = base.idBase;
        }
      });
    },
    setTasks() {
      this.$store
        .dispatch("getPacketInfo", this.selectedPacket.id)
        .then(() => {
          if (this.packetInfo.jobs && this.packetInfo.jobs.length > 0) {
            for (let job of this.packetInfo.jobs) {
              let templateId = this.cronTemplates.find(
                (tmp) => tmp.name === job.tpName
              ).id;
              let taskArray = job.tasks;
              // console.log(job);
              let templates;
              // console.log("taskArray", taskArray);
              this.$store
                .dispatch("getCronTemplates")
                .then((result) => {
                  templates = result;
                  return this.$store.dispatch("getBasesSection", job.idSection);
                })
                .then((basesInSection) => {
                  for (let task of taskArray) {
                    task.numOfRepeats = 1;
                    this.parseIncomingParams(task, basesInSection);
                  }
                  const newJob = {
                    templateId,
                    idSection: job.idSection,
                    disable: job.disable === "0" ? false : true,
                    taskArray,
                    basesInSection,
                    templates,
                    showJobTasks: true,
                  };
                  // this.jobArray.push(newJob);
                  let index = +job.nn - 1;
                  this.jobArray.splice(index, 0, newJob);
                  // this.jobArray[index] = newJob;
                })
                .catch((error) => {
                  console.error(error);
                });
            }
          } else {
            this.addJob();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    baseLabel(base) {
      let label = base.bname;
      if (base.balias && base.comment) {
        label += " (" + base.balias + ") -- " + base.comment;
      } else if (base.balias) label += " (" + base.balias + ")";
      else if (base.comment) label += " -- " + base.comment;
      return label;
    },
  },
  watch: {
    jobsFlag() {
      if (this.jobsFlag) this.setTasks();
    },
  },
  computed: {
    ...mapGetters([
      "selectedPacket",
      "packetInfo",
      "getAppsArray",
      "templateTasks",
      "cronTemplates",
      "jobsFlag",
    ]),
  },
  mixins: [arrayWorkMixin],
};
</script>

<style scoped src="./items.css">
</style>
<style scoped>
.tasks-list {
  margin-left: 2px;
  margin-top: 15px;
}
.tasks-list-item {
  margin-left: 5px;
  display: flex;
  justify-content: space-between;
}
.task-text-general:before {
  content: "\2022";
  margin-right: 3px;
}
.tasks-list-item .el-select {
  width: 220px;
  transform: scale(0.8);
  margin-right: -15px;
}
.task-container-label {
  font-weight: 600;
}
.task-text-general {
  margin: auto 0px;
  /* background-color: red; */
}
.copy-number {
  transform: scale(0.7);
  width: 50px;
  margin: auto 0px;
  padding: 0px 0px;
  /* margin-right: 10px; */
}
.select-line {
  display: flex;
  justify-content: space-between;
  margin: 5px 0px;
  word-break: normal;
}
.select-line label {
  margin: auto 0px;
  margin-left: 5px;
}
.right-side-container {
  margin-right: 6px;
}
.all-bases-button {
  padding: 5px 8px;
  margin: 0px 0px;
}
.delete-button {
  margin-right: -9px;
}
</style>